import { render, staticRenderFns } from "./CommunityRanking.vue?vue&type=template&id=d613b7c2&scoped=true&"
import script from "./CommunityRanking.vue?vue&type=script&lang=js&"
export * from "./CommunityRanking.vue?vue&type=script&lang=js&"
import style0 from "./CommunityRanking.vue?vue&type=style&index=0&id=d613b7c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d613b7c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAvatar,VCol,VContainer,VDivider,VIcon,VRow,VSelect})
